/* ROI calculator — client-provided logic, scoped to each [data-roi-calculator] instance. */
(function () {
  const DEFAULTS = {
    customer: 'Example Machine Shop',
    machines: 10,
    machineRate: 150,
    sumpGallons: 75,
    cleanouts: 1,
    cleaningHours: 5,
    laborRate: 20,
    concentration: 7.5,
    coolantCost: 30,
    disposalCost: 1,
    investment: 7990
  };
  const IDS = ['customer', 'machines', 'machineRate', 'sumpGallons', 'cleanouts', 'cleaningHours', 'laborRate', 'concentration', 'coolantCost', 'disposalCost', 'investment'];
  const cash = (n) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(n);

  function init(root) {
    if (root.dataset.roiReady) return;
    root.dataset.roiReady = 'true';

    const defaults = Object.assign({}, DEFAULTS);
    const investment = Number(root.dataset.defaultInvestment);
    if (investment > 0) defaults.investment = investment;

    const input = (id) => root.querySelector(`[data-roi-input="${id}"]`);
    const out = (id) => root.querySelector(`[data-roi-out="${id}"]`);
    const num = (id) => Math.max(0, Number(input(id).value) || 0);

    function calc() {
      const m = num('machines'),
        n = num('cleanouts'),
        g = num('sumpGallons'),
        wh = m * n * num('cleaningHours'),
        sh = m * n * g * 0.02,
        wm = wh * num('machineRate'),
        sm = sh * num('machineRate'),
        wl = wh * num('laborRate'),
        sl = sh * num('laborRate'),
        wc = m * g * n * (num('concentration') / 100) * num('coolantCost'),
        sc = wc / 2,
        wd = m * g * n * num('disposalCost'),
        sd = wd / 2,
        wt = wm + wl + wc + wd,
        st = sm + sl + sc + sd,
        s = wt - st,
        p = s > 0 ? num('investment') / (s / 12) : null,
        f = s * 5 - num('investment');

      out('a').textContent = wh.toFixed(1) + ' hr';
      out('b').textContent = sh.toFixed(1) + ' hr';
      [['c', wm], ['d', sm], ['e', wl], ['f', sl], ['g', wc], ['h', sc], ['i', wd], ['j', sd], ['k', wt], ['l', st], ['savings', s], ['five', f]].forEach((x) => {
        out(x[0]).textContent = cash(x[1]);
      });
      out('payback').textContent = p === null ? '—' : p.toFixed(1);
      out('name').textContent = input('customer').value || 'Customer ROI';
    }

    function load() {
      IDS.forEach((id) => {
        input(id).value = defaults[id] ?? '';
      });
      calc();
    }

    function print() {
      const html = document.documentElement;
      const cleanup = () => {
        html.classList.remove('roi-printing');
        root.classList.remove('roi-calc--printing');
        window.removeEventListener('afterprint', cleanup);
      };
      html.classList.add('roi-printing');
      root.classList.add('roi-calc--printing');
      window.addEventListener('afterprint', cleanup);
      window.print();
    }

    IDS.forEach((id) => input(id).addEventListener('input', calc));
    root.querySelector('[data-roi-reset]').addEventListener('click', load);
    root.querySelector('[data-roi-print]').addEventListener('click', print);
    load();
  }

  function initAll() {
    document.querySelectorAll('[data-roi-calculator]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
